// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Yyw6","info":"Note_info__4FLYL","note":"Note_note__251ee","actions":"Note_actions__3_hrl"};